const sortString = (data, key) => {
  return data.sort((a, b) => {
    if (key) {
      return a[key].localeCompare(b[key]);
    }
    return a.localeCompare(b);
  });
};

export default sortString;
